import React from "react";
import Button from "../general/Button/Button";
import "./ShowcaseCard.css";

const ShowcaseCard = ({
  name,
  preview,
  type,
  description,
  category,
  onOpenSpecs,
}) => {
  return (
    <article className="showcase-card-container">
      {preview && (
        <div className="showcase-card-preview">
          {type === "video" ? (
            <video src={preview} muted loop autoPlay playsInline />
          ) : (
            <img src={preview} alt={name} />
          )}
          <span className="showcase-card-badge">{category}</span>
        </div>
      )}


      <h3 className="showcase-card-title">{name}</h3>
      <p className="showcase-card-description">{description}</p>

      <Button
        variant="primary"
        fullWidth
        onClick={onOpenSpecs}
      >
        View Full Specs
      </Button>
    </article>
  );
};

export default ShowcaseCard;
